import api from '../api';

const SW_PATH = '/otoflow-sw.js';
const PROMPT_KEY = 'otoflow_webpush_prompted_v1';
let initPromise = null;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

async function ensurePermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'granted' || Notification.permission === 'denied') {
    return Notification.permission;
  }
  if (localStorage.getItem(PROMPT_KEY) === '1') return 'default';
  localStorage.setItem(PROMPT_KEY, '1');
  try {
    return await Notification.requestPermission();
  } catch {
    return 'default';
  }
}

export async function initWebPushSubscription() {
  if (initPromise) return initPromise;
  initPromise = (async () => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
    if (!window.isSecureContext) return false;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;

    const permission = await ensurePermission();
    if (permission !== 'granted') return false;

    const registration = await navigator.serviceWorker.register(SW_PATH, { scope: '/' });
    let publicKey = '';
    try {
      const { data } = await api.get('/bildirimler/webpush/public-key');
      publicKey = String(data?.publicKey || '').trim();
    } catch {
      return false;
    }
    if (!publicKey) return false;

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    await api.post('/bildirimler/webpush/subscribe', {
      subscription: subscription.toJSON(),
    });
    return true;
  })()
    .catch(() => false)
    .finally(() => {
      initPromise = null;
    });
  return initPromise;
}
